/**
 * Created by mukund on 8/24/17.
 */

angular.module('mediacloudApp')
    .directive('searchResults', function(){

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/collection/directives/search-results/search-results.html',
            scope: {
                parent: '=',
                openContent: '&',
                results: '=',
                currentcollection: '='
            },
            link: function(scope, element, attrs){
                scope.searchResultsPerPage = 3;
                scope.activeView = 'list';
            }
        }
    });
